const awsconfig = {
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL || 'us-east-1_guEtFcU8b',
        userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '1bu08ecb8gb77u7eppligb22ue',
      }
    },
  };
  
  export default awsconfig;
  